import React from 'react'
import { NavLink as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { red } from '@material-ui/core/colors';
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Button, Card, CardHeader, ClickAwayListener, Grid, Grow, IconButton, MenuItem, MenuList, Paper, Popper, Typography } from '@material-ui/core';
import { IAMAction } from '../../actions';
import LogoImg from "../../assets/images/ericssonWhite.png";
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

const useStyles = makeStyles((theme) => ({
    rootDesktop: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    rootTablet: {
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5),
    },
    rootMobile: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    logo: {
        height: theme.spacing(4),
        width: theme.spacing(4),
    },
    avatar: {
        height: theme.spacing(5),
        width: theme.spacing(5),
        backgroundColor: red[500],
    },
    item: {
        display: "flex",
        padding: 2,
    },
    button: {
        justifyContent: "flex-start",
        textTransform: "none",
        width: "auto",
    },
    active: {
        backgroundColor: theme.palette.primary.main,
    },
}));

const CustomRouterLink = React.forwardRef((props, ref) => (
    <div ref={ref} style={{ flexGrow: 1 }}>
        <RouterLink {...props} />
    </div>
));

const Profile = ({ profile, navginations }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const onLogout = (event) => {
        IAMAction.logout(dispatch)
        handleClose(event)
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    return (
        <React.Fragment>
            <IconButton aria-controls={open ? 'menu-list-grow' : undefined} aria-haspopup="true" ref={anchorRef} onClick={handleToggle}>
                <Avatar className={classes.avatar}>
                    {profile.fname[0] + profile.lname[0]}
                </Avatar>
            </IconButton>
            <Popper style={{ zIndex: 200 }} open={open} anchorEl={anchorRef.current} placement='bottom-end' transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    {
                                        navginations.map((navgination) => (
                                            navgination.pgid === 'usermanagement' ? (
                                                profile.accesslvl === 'admin' || profile.accesslvl === 'superadmin' ? (
                                                    <RouterLink to={navgination.href[0]}>
                                                        <MenuItem key={navgination.pgid} onClick={handleClose}>
                                                            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                                                                <Grid item key={navgination.pgid + '-icon'}>
                                                                    {navgination.icon}
                                                                </Grid>
                                                                <Grid item key={navgination.pgid}>
                                                                    <Typography variant='h6' color='textSecondary'>{navgination.title}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </MenuItem>
                                                    </RouterLink>
                                                ) : null
                                            ) : (
                                                <RouterLink to={navgination.href[0]}>
                                                    <MenuItem key={navgination.pgid} onClick={handleClose}>
                                                        <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                                                            <Grid item key={navgination.pgid + '-icon'}>
                                                                {navgination.icon}
                                                            </Grid>
                                                            <Grid item key={navgination.pgid}>
                                                                <Typography variant='h6' color='textSecondary'>{navgination.title}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </MenuItem>
                                                </RouterLink>
                                            )
                                        ))
                                    }
                                    <MenuItem onClick={onLogout}>
                                        <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                                            <Grid item key='logout-icon'>
                                                <PowerSettingsNewIcon color='disabled' />
                                            </Grid>
                                            <Grid item key='logout'>
                                                <Typography variant='h6' color='textSecondary'>Logout</Typography>
                                            </Grid>
                                        </Grid>
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </React.Fragment>
    )
}

const NavBar = ({ profile, pages }) => {
    const classes = useStyles();
    const pathname = window.location.pathname

    return (
        <React.Fragment>
            <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                {
                    pages.map((page) => (
                        pathname !== page.href[0] ? (
                            <Grid item key={page.pgid}>
                                <Button disableRipple key={page.pgid} activeClassName={classes.active} className={classes.button} component={CustomRouterLink} to={page.href[0]}>
                                    <Typography variant='h5' color='textSecondary'>{page.title}</Typography>
                                </Button>
                            </Grid>
                        ) : null
                    ))
                }
            </Grid>
        </React.Fragment>
    )
}

const NavigationBar = ({ pages, profile, deeplink = false, responsive }) => {
    const classes = useStyles();

    return (
        <Card className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop}>
            {
                deeplink ? (
                    <CardHeader
                        style={{ paddingTop: 5, paddingBottom: 0 }}
                        avatar={
                            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                                <Grid item><img className={classes.logo} src={LogoImg} /></Grid>
                                <Grid item><Typography variant='h3' color='textSecondary'>{responsive.isDesktopOrLaptop || responsive.isTablet ? 'Ericsson Support Portal' : responsive.isMobile ? 'ESP' : null}</Typography></Grid>
                            </Grid>
                        }
                    />
                ) : (
                    <CardHeader
                        style={{ paddingTop: 5, paddingBottom: 0 }}
                        avatar={
                            <RouterLink to={'/homepage'}>
                                <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                                    <Grid item><img className={classes.logo} src={LogoImg} /></Grid>
                                    <Grid item><Typography variant='h3' color='textSecondary'>{responsive.isDesktopOrLaptop || responsive.isTablet ? 'Ericsson Support Portal' : responsive.isMobile ? 'ESP' : null}</Typography></Grid>
                                </Grid>
                            </RouterLink>
                        }
                        action={<Profile profile={profile} navginations={pages[1]} />}
                    />
                )
            }
        </Card>
    )
}

export default NavigationBar
